// Publishes non-personal lead signals to Shopify's existing customer-events API.
// A connected analytics pixel must subscribe before these appear in its reports.
const pendingKey = 'ny-engine-quote-pending';
const consentAllowsAnalytics = () => {
  try {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  } catch {
    return false;
  }
};

function publish(name, data) {
  if (!consentAllowsAnalytics() || window.Shopify?.designMode) return;
  const analytics = window.Shopify?.analytics;
  if (typeof analytics?.publish !== 'function') return;
  try {
    Promise.resolve(analytics.publish(name, data)).catch(() => {});
  } catch {
    // Analytics must never interrupt an inquiry or navigation.
  }
}

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[href^="mailto:"]') : null;
  if (!link) return;
  publish('ny_engines:email_clicked', { contact_method: 'email' });
});

document.addEventListener('submit', (event) => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.matches('.ny-quote__form')) return;
  if (window.Shopify?.designMode || !consentAllowsAnalytics() || !event.target.checkValidity()) return;
  try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch {}
});

function reportQuoteSuccess() {
  if (!consentAllowsAnalytics()) return;
  const success = document.querySelector('[data-ny-quote-success]');
  const failure = document.querySelector('.ny-quote__status--error');
  if (!success && !failure) return;
  try {
    const pending = Number(sessionStorage.getItem(pendingKey));
    sessionStorage.removeItem(pendingKey);
    if (success && pending > 0 && Date.now() - pending < 15 * 60 * 1000) {
      publish('ny_engines:quote_submitted', { form_name: 'engine_quote', contact_method: 'form' });
    }
  } catch {}
}

reportQuoteSuccess();
document.addEventListener('visitorConsentCollected', reportQuoteSuccess);

// Shopify may expose customerPrivacy after this module runs. Recheck a
// successful form return when its first-party consent feature becomes ready.
try {
  const shopify = window.Shopify;
  if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed !== 'function' && typeof shopify?.loadFeatures === 'function') {
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
      if (!error) reportQuoteSuccess();
    });
  }
} catch {
  // A missing or failing Shopify feature must never interrupt the storefront.
}
